<template>
  <IconWrapper v-if="filled" name="file" :color="color" fillMode="fill">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.2525 2C13.5099 2 13.7079 2.21 13.7079 2.46V5.68C13.7079 7.51 15.203 9.01 17.0149 9.02C17.7673 9.02 18.3614 9.03 18.8168 9.03C19.1238 9.03 19.6287 9.02 20.0545 9.02C20.302 9.02 20.5 9.22 20.5 9.47V17.51C20.5 19.99 18.5099 22 16.0446 22H8.17327C5.59901 22 3.5 19.89 3.5 17.29V6.51C3.5 4.03 5.5 2 7.96535 2H13.2525ZM15.1496 2.9062C15.1496 2.4752 15.6674 2.2612 15.9635 2.5722C17.0338 3.6962 18.9041 5.6612 19.9496 6.7592C20.2387 7.0622 20.0268 7.5652 19.61 7.5662C18.7961 7.5692 17.8367 7.5662 17.1466 7.5592C16.0516 7.5592 15.1496 6.6482 15.1496 5.5422V2.9062Z"
        fill="#1B1B1E"
      />
    </svg>
  </IconWrapper>
  <IconWrapper v-else name="file" :color="color" fillMode="stroke">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9743 2C14.0172 2 14.0593 2.00362 14.1003 2.01056L14.2367 2.0113C14.4407 2.0113 14.6357 2.0943 14.7777 2.2413L19.8437 7.5203C19.9767 7.6593 20.0517 7.8463 20.0517 8.0393V17.3393C20.0557 19.8083 18.0497 21.8393 15.5807 21.8653L7.39966 21.8663C4.92666 21.8233 2.95866 19.7863 3.00066 17.3263V6.4903C3.05766 4.0093 5.10666 2.0113 7.56966 2.0113L13.8482 2.01056C13.8892 2.00362 13.9313 2 13.9743 2ZM13.224 3.511L7.57266 3.5113C5.91466 3.5113 4.53966 4.8533 4.50066 6.5083V17.3393C4.47166 18.9863 5.77866 20.3383 7.41366 20.3663L7.56066 20.3653H15.5727C17.2147 20.3473 18.5537 18.9903 18.5517 17.3403L18.551 8.983L16.5433 8.984C14.7123 8.979 13.2243 7.487 13.2243 5.659L13.224 3.511ZM14.724 4.352L14.7243 5.659C14.7243 6.663 15.5413 7.481 16.5453 7.484L17.728 7.483L14.724 4.352Z"
        fill="#1B1B1E"
      />
    </svg>
  </IconWrapper>
</template>

<script setup lang="ts">
import IconWrapper from './wrapper/wrapper.vue'

import type { ColorsType } from '@/types'

defineProps<{
  color: ColorsType
  filled?: boolean
}>()
</script>
